<template>
    <div class="m-3">
        <div
            v-if="logic == 'booked' || logic == 'pup'"
            class="pr-1 pr-md-12 pl-1 pl-md-0 py-3 text-justify"
        >
            This tracker is currently in use, please use another tracker to track your booking.
        </div>
        <div v-else-if="!bookings.length" class="pr-1 pr-md-12 pl-1 pl-md-0 py-3 text-justify">
            You currently have no booked bookings, please book a booking to link it to the tracker.
        </div>
        <table v-else class="table-fixed w-full">
            <thead class="bg-gray-500 text-white text-left">
                <th
                    class="w-2/10 pr-1 pr-md-12 pl-2 pl-md-3 py-3 font-semibold rounded-l-md text-left"
                >
                    Booking ID
                </th>
                <th class="w-5/10 px-2 px-md-8 py-3 font-semibold">To</th>
                <th class="w-3/10 px-2 pl-md-8 py-3 font-semibold">Actions</th>
            </thead>
            <tbody>
                <tr v-for="booking in bookings" :key="booking.id" class="text-base text-gray-700">
                    <td class="py-3 pr-2 pr-md-12 text-left pl-3">
                        {{ booking.id }}
                    </td>
                    <td class="py-3 py-md-3 px-1 px-md-8 text-left">
                        {{ booking.deliveryLocation.data.name }}
                    </td>
                    <td class="py-3 px-md-1 px-md-8 text-left">
                        <span
                            @click="linkBooking(booking.id)"
                            class="p-2 p-md-3 bg-blue-400 rounded text-white font-semibold cursor-pointer hover:bg-blue-200"
                        >
                            Link Booking</span
                        >
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
</template>
<script>
import { FH_CONFIG } from "../../config";

export default {
  name: "tracker",
  components: {},
  props: ["bookings", "trackerId", "logic"],
  data() {
    return {
      form: {
        layout: 'horizontal',
        eroadWhereDeviceId: '',
        email: '',
        bookingId: null
      },
    };
  },
  methods: {
    linkBooking(bookingId) {
      this.loading = true;
      axios
        .post("/send-freight/tracker/link", [
          this.trackerId,
          bookingId
        ])
        .then((res) => {
            window.location.href = res.data;
        });
    },
  },
};
</script>

<style>
@import "/landing/css/app.css";

tr:nth-child(even) {
    background-color: #f7fafc;
}
</style>
